import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function ReActAgent() {

    return (
        <div>
            <DHeader>Building a Reasoning Agent with Laeyerz</DHeader>
       
            <DText>
              In Laeyerz, developers can build agents for their tasks. These can also be integerated into workflows to make them Agentic.
              The Laeyerz Agent is inspired by the ReACT architecture. Agents built in Laeyerz use an LLM to Reason and Tools to Act.
            
            </DText>

            <br />
            <DText>
              To build the agent, first import the Agent from Laeyerz.
            </DText>

            <DCode>
                {`from laeyerz.agent.Agent import Agent`}
            </DCode>

            <br />

            <DText>
              Create an instance of the Agent as shown below.
            </DText>
            
            <DCode>
                {`agent = Agent( name="BillingAgent", config = {
        "api_key_path":'../../.env',
        "reasoner":reasoner_llm, 
        "role":agent_role, 
        "instructions":agent_instructions, 
        "tools":{}
    })
`}
            </DCode>

            <br />

            <DText>
              The Agent requires a reasoner LLM compatible with Laeyerz, to be passed in during creation.
              We will use a Laeyerz-compatible OpenAI LLM connector as the reasoner. These connectors are available in laeyerz-nodes repository on github.
              We will import the connector called OpenAINode and create an instance of it.
             </DText>

             <DCode>
              {`reasoner_llm =  LLM("BillingAgent",  config={"api_key": api_key, "model":"gpt-5-mini"})`}
             </DCode>

             <br />

            
            <DText>
              Along with the reasoner LLM, you also need to pass in the role and instructions to the agent. Examples of both are shown below.
              Also, if you have a .env file with API keys or config parameters that need to be passed to the agent, you can pass the path to the .env file using the 'api_key_path' parameter.
            </DText>
            <DCode>
              {`agent_role = "You are a billing agent"`}
            </DCode>


            <DCode>
                {`agent_instructions = """You will be provided a string which is an email or a message containing a user order.
You need to use the tools provided to you to extract the order, 
get the pricing for each item from the pricing table and 
calculate the total price for the order.
Calculate the tax for the order.
Generate an invoice for the order.


Response:
Respond to the user with a confirmation of the order(assume order is always confirmed).
And with the invoice generated for the order. Pass the latest items updated in the pricing calculator to the invoice generator.

Tools :
The tools you are provided are the:
-Order Extractor
-Pricing Calculator
-Total Calculator
-Tax Calculator
-Invoice Generator"""
`}
            </DCode>


            <br />

            <DText>
              The reasoner part of the Agent has now been setup along with instructions for the Agent to function.
            </DText>
            <DText>
              The next step is adding the Tools the Agent will need to use to perform the task.
            </DText>
       
        </div>
    )
}